import { AxiosResponse } from "axios";
import { get, post } from "utils";
import { ResponseDTO } from "types";

const baseUrl = `${process.env.REACT_APP_API_URL}/review`;

export const createReview = async (
  rating: number,
  comment: string,
  bookingId: string
): Promise<AxiosResponse<ResponseDTO<any>>> => {
  return post(baseUrl, { rating, comment, bookingId });
};

export const getUserReviews = async (
  userId: string
): Promise<AxiosResponse<ResponseDTO<any>>> => {
  return get(`${baseUrl}/user/${userId}`);
};

export const getServiceReviews = async (
  serviceId: string
): Promise<AxiosResponse<ResponseDTO<any>>> => {
  return get(`${baseUrl}/service/${serviceId}`);
};

export const getMyReceivedReviews = async (): Promise<
  AxiosResponse<ResponseDTO<any>>
> => {
  return get(`${baseUrl}/my`);
};
